var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2926_10643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.168 19.3672H7.20703C5.99533 19.3672 5.00977 18.3816 5.00977 17.1699V7.20898C5.00977 5.99728 5.99533 5.01172 7.20703 5.01172H17.168C18.3797 5.01172 19.3652 5.99728 19.3652 7.20898V17.1699C19.3652 18.3816 18.3797 19.3672 17.168 19.3672ZM7.20703 6.47656C6.80317 6.47656 6.47461 6.80512 6.47461 7.20898V17.1699C6.47461 17.5738 6.80317 17.9023 7.20703 17.9023H17.168C17.5718 17.9023 17.9004 17.5738 17.9004 17.1699V7.20898C17.9004 6.80512 17.5718 6.47656 17.168 6.47656H7.20703ZM3.54492 13.5078H2.8125C2.40864 13.5078 2.08008 13.1793 2.08008 12.7754V2.81445C2.08008 2.41059 2.40864 2.08203 2.8125 2.08203H12.7734C13.1773 2.08203 13.5059 2.41059 13.5059 2.81445V3.51025H14.9707V2.81445C14.9707 1.60275 13.9851 0.617188 12.7734 0.617188H2.8125C1.6008 0.617188 0.615234 1.60275 0.615234 2.81445V12.7754C0.615234 13.9871 1.6008 14.9727 2.8125 14.9727H3.54492V13.5078Z",
    fill: "#ccc"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2926_10643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#ccc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1b4fedbb08cb9f1d59d45b5918a546cd.svg";
export { ForwardRef as ReactComponent };